
import React from "react";
import ContractCard from "./ContractCard";
import EmptyState from "./EmptyState";
import heartLoading from "../../../assests/heartLoading.gif";
import preloader from "../../../assests/preloader1.gif";

const ContractList = ({
  activeTab,
  filteredContracts,
  mySubscriptions,
  myContracts,
  subscribedTables,
  handleSubscribe,
  handleViewProfile,
  handleViewContract,
  handleViewProduct,
  handleViewAssetDetails,
  handleViewResult,
  handleViewLineage,
  // Pagination props
  currentPage,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
  // Loading states
  loading,
  searchLoading,
  filterLoading,
}) => {
  // Loading component for search operations
  const SearchLoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={preloader} alt="Loading..." width={200} />
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">Searching...</p>
          <p className="text-gray-500 text-base">Fetching data based on your search</p>
        </div>
      </div>
    </div>
  );

  // Loading component for filter operations
  const FilterLoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={preloader} alt="Loading..." width={200} />
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">Applying filters...</p>
          <p className="text-gray-500 text-base">Updating results based on your selection</p>
        </div>
      </div>
    </div>
  );

  // Loading component for general operations (tab switch, initial load)
  const GeneralLoadingSpinner = () => (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center flex flex-col items-center justify-center space-y-4">
        <img src={preloader} alt="Loading..." width={200}/>
        <div className="space-y-2">
          <p className="text-gray-700 text-xl font-semibold">Loading...</p>
          <p className="text-gray-500 text-base">Hang tight! The resources are loading...</p>
        </div>
      </div>
    </div>
  );

  // Early return for loading states - these take absolute priority
  if (searchLoading) {
    return <SearchLoadingSpinner />;
  }

  if (filterLoading) {
    return <FilterLoadingSpinner />;
  }

  if (loading) {
    return <GeneralLoadingSpinner />;
  }

  // Generate page numbers array
  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 10; // Show max 10 page numbers
    
    if (totalPages <= maxVisiblePages) {
      // If total pages <= 10, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // If total pages > 10, show smart pagination
      if (currentPage <= 5) {
        // Show first 10 pages
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
      } else if (currentPage >= totalPages - 4) {
        // Show last 10 pages
        for (let i = totalPages - 9; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Show 5 pages before and 4 pages after current page
        for (let i = currentPage - 5; i <= currentPage + 4; i++) {
          pages.push(i);
        }
      }
    }
    
    return pages;
  };

  const renderPagination = () => {
    if (totalPages <= 1) {
      return null;
    }

    const pageNumbers = getPageNumbers();

    return (
      <div className="pagination-container">
        <div className="pagination-info">
          Showing {((currentPage - 1) * pageSize) + 1}-{Math.min(currentPage * pageSize, totalCount)} of {totalCount} items
        </div>
        
        <div className="pagination-controls">
          {/* Previous button */}
          <button
            className={`pagination-btn ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {/* Page numbers */}
          <div className="page-numbers">
            {pageNumbers.map((pageNum) => (
              <button
                key={pageNum}
                className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            ))}
          </div>

          {/* Next button */}
          <button
            className={`pagination-btn ${currentPage === totalPages ? 'disabled' : ''}`}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    );
  };
   const PaginationRender = () => {
    if (totalPages <= 1) {
      return null;
    }

    const pageNumbers = getPageNumbers();

    return (
      <div className="pagination-controlsss">

        
        <div className="pagination-controls">
          {/* Previous button */}
          <button
            className={`pagination-btn ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {/* Page numbers */}
          <div className="page-numbers">
            {pageNumbers.map((pageNum) => (
              <button
                key={pageNum}
                className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
                onClick={() => onPageChange(pageNum)}
              >
                {pageNum}
              </button>
            ))}
          </div>

          {/* Next button */}
          <button
            className={`pagination-btn ${currentPage === totalPages ? 'disabled' : ''}`}
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="contract-list">
      {activeTab === "all" && (
        filteredContracts && filteredContracts.length > 0 ? (
            <>
              {/* Total Results Count Display */}
              <div className="flex justify-between ">
                <div className="mt-[9px]">
                  <span className="text-[#bb1ccc] font-medium text-sm">
                   There are {totalCount} results found
                  </span>
                </div>
                <div>
              <div>{PaginationRender()}</div>
 

                </div>
              </div>

              {filteredContracts.map((contract) => (
                <ContractCard
                  key={contract.id}
                  contract={contract}
                  isSubscribed={subscribedTables.includes(contract.id)}
                  onSubscribe={() => handleSubscribe(contract)}
                  onViewProfile={() => handleViewProfile(contract)}
                  onViewContract={() => handleViewContract(contract)}
                  onViewProduct={() => handleViewProduct(contract)}
                  onViewAssetDetails={() => handleViewAssetDetails(contract)}
                  onViewResult={() => handleViewResult(contract)}
                  onViewLineage={() => handleViewLineage(contract)}
                  activeTab={activeTab}
                />
              ))}
              
              {/* Pagination */}
              {renderPagination()}
            </>
          ) : (
            <EmptyState message="No data contracts available" />
          )
      )}

      {activeTab === "mySubscriptions" && (
        mySubscriptions && mySubscriptions.length > 0 ? (
          <>
            {/* Total Results Count Display */}
            <div className="flex justify-end mb-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2">
                <span className="text-blue-800 font-medium text-sm">
                  {totalCount} results found
                </span>
              </div>
            </div>

            {mySubscriptions.map((contract) => (
              <ContractCard
                key={contract.id}
                contract={contract}
                isSubscribed={subscribedTables.includes(contract.id)}
                onSubscribe={() => handleSubscribe(contract)}
                onViewProfile={() => handleViewProfile(contract)}
                onViewContract={() => handleViewContract(contract)}
                onViewProduct={() => handleViewProduct(contract)}
                onViewAssetDetails={() => handleViewAssetDetails(contract)}
                onViewResult={() => handleViewResult(contract)}
                onViewLineage={() => handleViewLineage(contract)}
                activeTab={activeTab}
              />
            ))}
            
            {/* Pagination */}
            {renderPagination()}
          </>
        ) : (
          <EmptyState message="No subscriptions found" />
        )
      )}

      {activeTab === "myContracts" && (
        myContracts && myContracts.length > 0 ? (
          <>
            {/* Total Results Count Display */}
            <div className="flex justify-end mb-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-2">
                <span className="text-blue-800 font-medium text-sm">
                  {totalCount} results found
                </span>
              </div>
            </div>

            {myContracts.map((contract) => (
              <ContractCard
                key={contract.id}
                contract={contract}
                isSubscribed={subscribedTables.includes(contract.id)}
                onSubscribe={() => handleSubscribe(contract)}
                onViewProfile={() => handleViewProfile(contract)}
                onViewContract={() => handleViewContract(contract)}
                onViewProduct={() => handleViewProduct(contract)}
                onViewAssetDetails={() => handleViewAssetDetails(contract)}
                onViewResult={() => handleViewResult(contract)}
                onViewLineage={() => handleViewLineage(contract)}
                activeTab={activeTab}
              />
            ))}
            
            {/* Pagination */}
            {renderPagination()}
          </>
        ) : (
          <EmptyState message="No contracts found" />
        )
      )}
    </div>
  );
};

export default ContractList;
